<template>
   <div>

      <div class="head">
         <proHead></proHead>
      </div>
      <div class="proComOne">
         <div class="main">
            <div class="con">
               <div class="p1 tit-58">{{gudingziduan.tuijian.pone1_1}}</div>
               <div class="p2 tit-25 mt-10">{{gudingziduan.tuijian.pone1_2}}</div>
               <div class="flex mt-100 more">
                  <div class="more1 tit-20 montserRegular" @click="$dakai('/proComTwo')">{{gudingziduan.tuijian.pone1_3}}</div>
               </div>
               <div class="copyRight">
                  <p>Copyright © 2021 GoodWe Technologies Co..Ltd </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import proHead from '../../../components/proComSystem/header.vue'

export default {
   components: {
      proHead
   },
   data() {
      return {
			 gudingziduan: {}
      }
   },
   watch: {
   	    '$store.state.cunyuanyan': {
   	      handler(newValue, oldValue) {
   	        // console.log('语言已更新:', newValue);
   	        this.gudingziduan=this.$store.state.cunyuanyan
   			// console.log(this.gudingziduan,'video')
   	      },
   	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
   	    }
   	},
   created() {
	   this.$cun('Tindex',1)
	   this.$cun('Menuindex',3)
	   this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
	   this.gudingziduan=this.$store.state.cunyuanyan
	   console.log(999)
	   console.log(this.gudingziduan)
   },
   computed: {
   },
   methods: {
   },

}
</script>
<style lang="scss" scoped>
* {
   line-height: 1;
}

// 按钮
.more1 {
   padding: .2rem .72rem;
   border-radius: 30px;
   color: #fff;
   cursor: pointer;
}

// 头部
::v-deep .proConHead {
   padding: .5rem 2%;
}

::v-deep .proConHead .headre {
   display: none;
}

// 主体部分
.proComOne {
   height: 100vh;
   background: url('../../../assets/pc/proComSystem/proComOne-bj.png') no-repeat center;
   background-size: cover;

   .main {
      height: 100%;
      padding: 0 8%;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .con .p1 {
         color: #333333;
         font-family: "montserMedium";
      }

      .con .p2 {
         color: #333333;
         font-family: "montserLight";
      }

      .copyRight {
         width: 100%;
         padding: 0 8%;
         box-sizing: border-box;
         left: 0;
         position: absolute;
         bottom: 6%;
      }

      .copyRight p {
         color: #a4a4a4;
         font-family: "montserLight";
      }
   }
}

// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width:767px) {
	.proComOne {background-position-x: 0%;}
	.proComOne .con {width: 100%; text-align: center; margin-bottom: 2rem;}
   .proComOne .con .more { justify-content: center; margin-top: .5rem;}
   .proComOne .con .more .more1 {padding: 0.3rem 1rem;    font-size: var(--font30);}


   .proComOne .main .copyRight {padding: 0 4%;}
}


</style>
